import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-multi-line-event-types',
  templateUrl: './multi-line-event-types.component.html',
  styleUrl: './multi-line-event-types.component.scss',
})
export class MultiLineEventTypesComponent {
  isLoading = true;

  label: any = {
    show: true,
    position: 'inside',
    formatter: (params) =>
      params.value >= 5 ? parseInt(params.value) + '%' : '',
    fontWeight: 'bold',
    color: '#fff',
  };

  options: echarts.EChartsOption = {
    grid: { left: 40, right: 30, top: 40, bottom: 80 },
    stack: 'total',
    yAxis: {
      max: 100,
    },

    series: [
      {
        type: 'bar',
        stack: 'total',
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
    ],
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.multiLineEventTypes$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('multiLineEventTypes');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getMultiLineEventTypes().subscribe();
  }

  get series() {
    return this.analyticsService.multiLineEventTypes$.value?.series;
  }

  get labels() {
    return this.analyticsService.multiLineEventTypes$.value?.labels;
  }
}
